import { render, staticRenderFns } from "./trainingReport.vue?vue&type=template&id=b8eb5e98&scoped=true"
import script from "./trainingReport.vue?vue&type=script&lang=js"
export * from "./trainingReport.vue?vue&type=script&lang=js"
import style0 from "./trainingReport.vue?vue&type=style&index=0&id=b8eb5e98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8eb5e98",
  null
  
)

export default component.exports